/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Row } from "reactstrap";
import Lightbox from "react-image-lightbox";
import classnames from "classnames";
import ThumbnailImage from "./ThumbnailImage";
import "react-image-lightbox/style.css";

export default class extends Component {
  static clickImage() { }

  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false
    };
  }

  render() {
    const { items } = this.props;
    const { photoIndex, isOpen } = this.state;
    return (
      <Row>
        {items.map((imgUrl, index) => (
          <div key={imgUrl} role="button" tabIndex={index} onClick={() => this.setState({ isOpen: true, photoIndex: index })} onKeyPress={() => { }}>
            <img alt="" src={imgUrl} className={`img-thumbnail list-thumbnail align-self-center rounded}`} />
          </div>
        ))}
        {isOpen && (
          <Lightbox
            mainSrc={items[photoIndex]}
            nextSrc={items[(photoIndex + 1) % items.length]}
            prevSrc={items[(photoIndex + items.length - 1) % items.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + items.length - 1) % items.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % items.length
              })
            }
          />
        )}
      </Row>
    );
  }
}
